import React from "react";
import { InputWrapper, Input, ErrorMessage } from "@/lib/styles";

export default function InputText(props: any) {
  const {
    _key,
    placeholder = "",
    inputType = "text",
    name = "",
    required = false,
    validErrorText,
    inputValidErrorText,
  } = props;
  return (
    <InputWrapper
      key={_key}
      onFocus={(e) => {
        e.target.parentElement?.classList.remove("error");
      }}
    >
      <label htmlFor={name}>{placeholder}</label>
      <Input
        type={inputType}
        id={name}
        placeholder={`${placeholder}${required ? "*" : ""}`}
        name={name}
        required={required}
      ></Input>
      <ErrorMessage> {inputValidErrorText ?? validErrorText} </ErrorMessage>
    </InputWrapper>
  );
}
